/**
 * Maximum number of custom views that can be saved on a single plan.
 * Custom views are shared across all view types (grid, board, chart, etc.), so this limit is
 * not specific to any one view.
 */ export const MAX_CUSTOM_VIEWS_COUNT = 25;
/** Maximum length of a Custom View display name. */ export const MAX_CUSTOM_VIEW_NAME_LENGTH = 100;
/** Payload generation for views this client writes. Bumped only when the saved shape changes. */ export const CUSTOM_VIEW_SCHEMA_VERSION = 1;
/** localStorage key holding all serialized Custom Views. */ export const CUSTOM_VIEWS_LOCAL_STORAGE_KEY = "custom-views";
